import React from 'react';
import { useContext } from "react";

const UserContext = React.createContext();

export default UserContext;